<template>
  <div class="search col-xl-5 mx-auto">
    <div>
      <h5><b>NJCRIB ERM-14</b> Forms</h5>

      <b-form-group>
        <b-form-row>
          <b-form-group label="Submission ID" class="col-6">
            <b-form-input v-model="submissionId" />
          </b-form-group>
          <b-form-group label="Entity Name" class="col-6">
            <b-form-input v-model="entityName" />
          </b-form-group>
        </b-form-row>
      </b-form-group>

      <b-form-group>
        <b-form-row>
          <b-form-group label="Date From" class="col-6">
            <datepicker 
              :value="dateFrom ? moment(dateFrom).toDate() : ''" 
              @selected="dateFrom = $event ? moment($event).format('YYYY-MM-DD') : ''" 
              input-class="form-control" 
              format="MM/dd/yyyy" 
              typeable></datepicker>
          </b-form-group>
          <b-form-group label="Date To" class="col-6">
            <datepicker 
              :value="dateTo ? moment(dateTo).toDate() : ''" 
              @selected="dateTo = $event ? moment($event).format('YYYY-MM-DD') : ''" 
              input-class="form-control" 
              format="MM/dd/yyyy" 
              typeable></datepicker>
          </b-form-group>
        </b-form-row>
      </b-form-group>

      <b-form-group>
        <b-form-row>
          <b-form-group label="User Name" class="col-6">
            <b-form-input v-model="userName" />
          </b-form-group>
          <b-form-group label="User Email" class="col-6">
            <b-form-input v-model="userEmail" />
          </b-form-group>
        </b-form-row>
      </b-form-group>

      <b-button variant="success" @click="search" class="mr-1">Search</b-button>
      <b-button variant="danger" @click="reset" class="ml-1">Reset</b-button>

      <b-table 
        striped 
        :items="submissions" 
        :fields="fields" 
        class="mt-3 table-light"
        show-empty
        small
        stacked="md"
        :current-page="currentPage"
        :per-page="perPage"
        >
        <template v-slot:cell(actions)="data">
          <b-button
            :to="{ name: 'change/list', params: { submissionId: data.item.submissionID }}"
            size="sm"
            variant="success">View</b-button>
        </template>
      </b-table>
      <b-pagination 
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"></b-pagination>
    </div>
  </div>
</template>

<script>
import SubmissionService from '../services/SubmissionService.js'

export default {
  name: 'submission-search',
  data() {
    return {
      fields: [
        { key: 'submissionID' , label: 'Submission ID', sortable: true },
        { key: 'status' , label: 'Status', sortable: true },
        { key: 'created' , label: 'Created', sortable: true, formatter: this.DateFormatter },
        { key: 'userEmail', label: 'User Email', sortable: true },
        { key: 'actions', label: '', sortable: false, thStyle: 'minWidth: 58px;' }
      ],
      submissions: [],
      submissionId: '',
      entityName: '',
      dateFrom: '',
      dateTo: '',
      userName: '',
      userEmail: '',
      currentPage: 1,
      perPage: 15
    }
  },
  computed: {
    totalRows() {
      return this.submissions.length 
    }
  },
  methods: {
    search() {
      SubmissionService.search(this.submissionId, this.entityName, this.dateFrom, this.dateTo, this.userName, this.userEmail).then(res => {
        this.submissions = res.data
      }).catch(() => {
        this.submissions = []
      })
    },
    reset() {
      this.submissionId = ''
      this.entityName = ''
      this.dateFrom = ''
      this.dateTo = ''
      this.userName = ''
      this.userEmail = ''
      this.submissions = []
    }
  }
}
</script>

<style scoped>
.search {
  min-height: 80vh !important;
}

.form-group {
  margin-bottom: 0.5rem !important;
}
</style>